import React, { useState, useEffect, useContext } from "react";
//
import { useNavigate } from "react-router";
import { StoreContext } from "../../../store/StoreProvider";
import fireAuth from "../../../api/firebase/auth/utils";
import useLocaleRoute from "../../../common/hooks/useLocaleRoute";
import urls from "../../../api/project/ApiUrls";
import { ROUTE_PATH } from "../../../config/CONSTANTS";

const useGotoWorkingArea = () => {
  //
  const navigate = useNavigate();
  // props
  // store
  const [state] = useContext(StoreContext);
  const { user } = state;
  const { locale } = user;
  // local state
  const isLoggedIn = fireAuth.isLoggedIn(user);

  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );

  useEffect(() => {
    // 當登入狀態,一律進入 sna page
    if (isLoggedIn) {
      navigate(handleLocaleRoute(ROUTE_PATH.Console));
    }
  }, []);

  return isLoggedIn;
};

export default useGotoWorkingArea;
